<template>
  <v-container fluid>
    <h3 class="mb-5">PDF generavimas</h3>

    <div
      class="dataContainer"
      @keydown.enter.prevent="saveData()"
      @keydown.esc.prevent="cancelData()"
    >
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="generavimasTab" dense>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              class="generavimas-tab"
              v-for="item in generavimasList"
              :key="item.value"
            >
              <h4>{{ item.label }}</h4>
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <el-overlay-loading :loading="loading" />

      <template v-if="showError">
        <v-row>
          <v-col cols="12">
            <v-alert dense outlined type="error">
              Klaida
            </v-alert>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-card-text>
                {{ errorMsg }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <v-tabs-items v-model="generavimasTab">
        <v-tab-item key="1">
          <v-row class="mt-5">
            <v-col cols="12" md="6">
              <el-text-field
                label="Žurnalo ID"
                tooltip="Administravimas. Pergeneravimas. Žurnalo ID"
                v-model="zug_id"
                v-mask="`##########`"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item key="2">
          <v-row class="mt-5">
            <v-col cols="12" md="6">
              <el-text-field
                label="Prašymo ID"
                tooltip="Administravimas. Pergeneravimas. Prašymo ID"
                v-model="pra_id"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item key="3">
          <v-row class="mt-5">
            <v-col cols="12" md="6">
              <el-text-field
                label="Prašymo ID"
                tooltip="Administravimas. Pergeneravimas. Prašymo ID"
                v-model="pra_id"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <v-footer class="form-footer">
      <el-button primary @click.native="saveData()" :loading="loading"
        >Formuoti</el-button
      >
      <el-button @click.native="cancelData()" :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  name: 'AdminGeneravimas',
  data() {
    return {
      loading: false,
      zug_id: null,
      pra_id: null,
      errorMsg: null,
      showError: false,
      generavimasTab: null,
      generavimasList: [
        {
          label: 'PDF generavimas',
          value: 1,
        },
        {
          label: 'Siunčiamų pranešimų generavimas',
          value: 2,
        },
        {
          label: 'NTR išrašų generavimas',
          value: 3,
        },
      ],
    }
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    generavimasUrl() {
      switch (this.generavimasTab) {
        case 0:
          return `admin/pergeneravimas/${this.zug_id}`
          break
        case 1:
          return `admin/pergeneravimas/prasymas/${this.pra_id}`
          break
        case 2:
          return `admin/pergeneravimas/prasymas-israsas/${this.pra_id}`
          break
      }
      return null
    },
  },
  watch: {
    generavimasTab(val) {
      this.showError = false
      this.zug_id = null
      this.pra_id = null
    },
  },
  created() {
    //
  },
  methods: {
    saveData() {
      this.loading = true
      this.showError = false

      this.$axios
        .post(this.generavimasUrl)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          this.errorMsg = err.response.data.message
          this.showError = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.showError = false
      this.zug_id = null
      this.pra_id = null
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 850px;
}
.taisykles-tab {
  max-width: 400px;
}
</style>
